"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHARGES = exports.MAYBACH_SUBBRAND = void 0;
exports.sortClasses = sortClasses;
exports.filterClassesByBlackList = filterClassesByBlackList;
const utils_1 = require("@/utils");
exports.MAYBACH_SUBBRAND = utils_1.SubBrand.MERCEDES_MAYBACH;
exports.CHARGES = {
    TK: 'DELIVERY',
    DF: 'DELIVERY',
    'TK-VAT': 'DELIVERY',
    DELIVERYCOST: 'DELIVERY',
};
function sortClasses(a, b) {
    const nameA = a.className.toUpperCase();
    const nameB = b.className.toUpperCase();
    if (nameA < nameB) {
        // Sort A before B
        return -1;
    }
    if (nameA > nameB) {
        // Sort B before A
        return 1;
    }
    // Does nothing
    return 0;
}
function filterClassesByBlackList(items, blacklist) {
    return items.filter((item) => !blacklist.includes(item.classId));
}
